import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    manager: {
      licence: {},
      device: {},
      app: {},
      profile: {}
    }
};

const searchbarSlice = createSlice({
    name: 'searchbar',
    initialState,
    reducers: {
      setLicenceKabinet: (state, {payload}) => {
        state.licenceKabinet = payload;            
      },
      resetLicenceKabinet: (state) => {
        state.licenceKabinet = {};
      },
      setdeviceKabinet: (state, {payload}) => {
        state.deviceKabinet = payload;         
      },
      resetdeviceKabinet: (state, {payload}) => {
        state.deviceKabinet = {};            
      },
      setKabinetSearchBar: (state, {payload}) => { 
        state[`${payload.active}Kabinet`] = payload.data;
      },
      setKabinetSearch: (state, {payload: {active, key, value}}) => { 
        state[`${active}Kabinet`][key] = value;
      },
      setManagerSearch: (state, {payload: {active, key, value}}) => {
        state.manager[active][key] = value;
      },
      resetManagerSearch: (state, {payload: {active, sort}}) => {
        state.manager[active] =  sort ? { sort } : {};
      }
    }
});

export const {
  setLicenceKabinet,
  resetLicenceKabinet,
  setdeviceKabinet,
  resetdeviceKabinet,  
  setKabinetSearch,
  setManagerSearch,
  resetManagerSearch
} = searchbarSlice.actions;

export default searchbarSlice.reducer;